import { GQLChannel, GQLPostType } from "graphql.generated";
import { Filters, FilterKey } from "./router-provider";

export const parseFilterString = (str = ""): Filters => {
    const res: Filters = {};
    if (!str) return res;
    str.split(";").forEach((grp) => {
        const [type, list] = grp.split("-");
        if (!type || !list) return;

        const values = list.split(".").filter(Boolean).map(decodeURIComponent).sort();

        switch (type as FilterKey) {
            case "ch":
                res.ch = values as GQLChannel[];
                break;
            case "pt":
                res.pt = values as GQLPostType[];
                break;
            case "in":
                res.in = values;
                break;
            case "ht":
                res.ht = values;
                break;
            case "tab":
                res.tab = values[0];
                break;
        }
    });

    return res;
};

export const buildFilterString = (obj: Filters): string =>
    Object.entries(obj)
        .filter(([, arr]) => arr && (Array.isArray(arr) ? arr.length : true))
        .map(([type, arr]) => `${type}-${(Array.isArray(arr) ? arr : [arr]).map(encodeURIComponent).join(".")}`)
        .join(";");

export const filtersEqual = (a: Filters, b: Filters): boolean => {
    const ka = Object.keys(a);
    const kb = Object.keys(b);
    if (ka.length !== kb.length) return false;
    for (const k of ka) {
        const A = a[k as FilterKey]!;
        const B = b[k as FilterKey]!;
        if (A.length !== B.length) return false;
        for (let i = 0; i < A.length; i++) if (A[i] !== B[i]) return false;
    }
    return true;
};

export const sortUnique = <T extends string>(arr: T[]): T[] => Array.from(new Set(arr)).sort();
